import { inject } from '@angular/core';
import { CanMatchFn } from '@angular/router';

import { SessionService } from '@/app/core/services/session';

export const authGuard: CanMatchFn = (route, segments) => {
  const sessionsService = inject(SessionService);

  if (sessionsService.isAuthenticated()) {
    return true;
  }

  sessionsService.navigateToLogin();
  return false;
};
